import React from 'react';
import Img from 'react-image';
import Link from 'gatsby-link';
import BackToTop from '../components/BackToTop';
import Iframe from '../components/Iframe';
import Sliderer from '../components/Slider';
import PCKitchen from '../components/index/PCKitchen';
import SPKitchen from '../components/index/SPKitchen';
import PCCoWorkingSpace from '../components/index/PCCoWorkingSpace';
import SPCoWorkingSpace from '../components/index/SPCoWorkingSpace';
import cotoiroLogo from '../static/images/cotoiro.png';
import iwabuchiLogo from '../static/images/iwabuchiyamorisha.png';
import linkIcon from '../static/images/icon/new_window.svg';

const IndexPage = () => (
  <main>{/* TODO: after fix */}
    <Sliderer />

    <div className="p-container">
      <div className="p-content -border-top">
        <h2 className="p-content__header">CONCEPT</h2>
      </div>
    </div>
    
    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__read">
          グルメなあなたの秘密基地。<br />
          「食を楽しむ」<br className="p-sp-content" />
          <br className="p-pc-content" />コワーキングスペースができました。
        </div>
      </div>
    </div>

    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__main">
          <p>
            みんなで食べる。美味しいものを、楽しく、自由に。<br />
            ここは食を楽しむための会員制キッチン&コワーキングスペース。<br />
            1人でも、仲間とでも、家族とでも。グルメな人が集まれば、あなたの日常はもっと美味しくなる。<br />
            名前は co-toiro＝コトイロ。<br />
            様々な人がこの場所に集い、様々なコト（事）とイロ（色）の滲み出す場所にしたいという<br className="p-pc-content" />
            想いが込められています。<br />
            使い方はあなた次第。レイアウトも自由自在です。<br />
            充実のキッチンに加え、仕事をしたい人のために、ネット環境とプリンターも備えています。<br />
            食好きであれば、だれでもウェルカム。<br />
            グルメな会員が開くイベントに参加したり、ふいに住民が持ってくるお土産に舌鼓を打ったり。<br />
            みんなでワイワイ、美味しいゴハンと過ごす時間を楽しみませんか？<br />
            <br />
            コトイロは、もっと食を楽しむコワーキングスペースへ。
          </p>
        </div>
      </div>
    </div>

    <div className="p-container">
      <div className="p-content">
        <h2 className="p-content__header">WHAT’S GOURMET × CO-WORKING</h2>
      </div>
    </div>
    
    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__read">
          グルメな利用者が集まれば、<br />
          いつもグルメのある<br />
          コワーキングになっていく。
        </div>
      </div>
    </div>

    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__main">
          <h3>グルメが楽しめる4つのポイント</h3>
          <ul>
            <li><span>&#9312;</span>充実のキッチンつき</li>
            <li><span>&#9313;</span>グルメな会員優遇プラン「グルメコワーキング会員（グルコワ）」</li>
            <li><span>&#9314;</span>充実のグルメイベント（会員の優先参加枠あり）</li>
            <li><span>&#9315;</span>グルメな<a href="https://shukubamachi-marche.localinfo.jp/" target="_blank" rel="noopener">マルシェ <Img src={linkIcon} alt="" /></a>を不定期開催</li>
          </ul>
          <h3>グルメコワーキング会員（グルコワ）プラン</h3>
          <p>
            グルメぶりが判明するとなれる、特別な会員制度です。<br />
            コワーキングの自由席利用権に、イベント開催無料権（コトイロ貸切無料権）つき。<br />
            自らの腕を振るうもよし、ゲストを呼んでパーティを開くもよし。<br />
            グルメな日々を満喫しましょう。
          </p>
        </div>
      </div>
    </div>
    
    <h2 className="p-content__header">{"WHAT'S co-toiro?"}</h2>

    <SPKitchen /> 
    <PCKitchen /> 

    <SPCoWorkingSpace />
    <PCCoWorkingSpace />

    <div className="p-container">
      <div className="p-content">
        <h2 className="p-content__header">STORY</h2>
      </div>
    </div>
    
    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__read">
          築60年の長屋をリノベーション。<br />
          コトとイロの滲みだす街の拠点へ。
        </div>
      </div>
    </div>

    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__main -justify">
          <p>
            岩淵町は、江戸時代には宿場町でした。それも、将軍が日光東照宮にお参りをする際に通る日光御成道で、いの一番に泊まっていた第一番の宿場町。<br />
            時は高度経済成長期。住居表示改変の際には、「岩淵」の名前を住民運動によって守り抜いたという歴史があるほど、住民が誇りをもっている街です。<br />
            <br />
            そんな歴史ある岩淵町で、コトイロのある敷地を管理する&#12849;ニッセンは元染色工場でした。<br />
            <br />
            宿場町だったという街の伝統と、染物工場のルーツを大切にしたいという想い。<br />
            この街だからこそ、様々な人がこの場所に集い、様々なコト（事）とイロ（色）の滲み出す場所をつくりたい。<br />
            そんな気持ちを込めて、コトイロと名付けました。
          </p>
        </div>
      </div>
    </div>

    {/*
    <div className="p-container">
      <div className="p-content">
        <h2 className="p-content__header">EVENT</h2>
      </div>
    </div>

    <div className="p-container -border-left">
      <Sliderer
        arrows={true}
        dots={false}
        slidesToShow={3}
      />
    </div>
    
    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__read">
          イベント名
        </div>
      </div>
    </div>

    <div className="p-container">
      <div className="p-content">
        <Slider />
      </div>
    </div>

    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__main">
          <p>
            イベントの説明が入ります。
          </p>
        </div>
      </div>
    </div>
    */}

    <div className="p-container">
      <div className="p-content">
        <h2 className="p-content__header">ACCESS</h2>
      </div>
    </div>

    <div className="p-container">
      <div className="p-content -center">
        <dl>
          <dt>address</dt>
          <dd>
            〒115-0041 東京都北区岩淵町15-13 co-toiro<br />
            東京メトロ南北線「赤羽岩淵駅」より徒歩2分<br />
            JR「赤羽駅」より徒歩10分
          </dd>
        </dl>
        <dl>
          <dt>e-mail</dt>
          <dd><a href="mailto:info@cotoiro.com">info@cotoiro.com</a></dd>
        </dl>
      </div>
    </div>

    <div className="p-container">
      <div className="p-map">
        <Iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3236.6477715123665!2d139.72167491526156!3d35.784027680170496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189304847ef2ab%3A0x5553a12f57a0f0b4!2zY28tdG9pcm8gaXdhYnVjaGnvvIjjgrPjg4jjgqTjg63vvIk!5e0!3m2!1sja!2sjp!4v1538486211808"
        />
      </div>
    </div>

    <div className="p-container">
      <div className="p-content">
        <h2 className="p-content__header">CONTACT</h2>
      </div>
    </div>

    <div className="p-container -border-left">
      <div className="p-content">
        <div className="p-content__main">
          <p>
            キッチン&コワーキングスペースについて、イベントなどについての詳しい情報は<br />下記よりお問い合わせのほど、よろしくお願いいたします。
          </p>
        </div>
      </div>
    </div> 

    <div className="p-container -bottom">
      <div className="p-content -center -top">
        <Link to="/kitchen#contact" className="c-button -secondary -half">お問い合わせ</Link>
      </div>
    </div>

    <div className="p-company">
      <div className="p-container">
        <div className="p-content -center">
          <h2 className="p-content__header">COMPANY</h2>
          <div className="p-content__logo-container">
            <Img src={iwabuchiLogo} alt="iwabuchi yamorisha logo" className="p-content__logo" />
          </div>
        </div>
      </div>

      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-content__main -justify">
            <p>
              （株）岩淵家守舎は2017年設立のまちづくり会社です。<br />
              「欲しい暮らしはつくれる」をコンセプトに、住民が欲しい暮らしを自然体で実現できる街づくりを岩淵町で実践しています。時代に合った東京の宿場町の姿と、街と共に暮らすあたらしい暮らしかたを提案します。
            </p>
          </div>
        </div>
      </div> 

      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-content__main -justify">
            <h3>【事業内容】</h3>
            <ul>
              <li>シェアキッチン付きコワーキングスペース「co-toiro iwabuchi」の企画・運営</li>
              <li>DIY可能な賃貸アパート「コトイロの家」の企画・運営</li>
              <li>「宿場町まるしぇ」などイベントの企画・運営</li>
              <li>空き家物件のリノベーション・プロデュース</li>
            </ul>
          </div>
        </div>
      </div> 

      <div className="p-container">
        <div className="p-content -center u-mtl">
          <a
            href="https://www.facebook.com/iwabuchiyamori"
            className="p-company__button -secondary -link-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            会社サイトへ
          </a>
        </div>
      </div>
    </div>
    
    <BackToTop classes="p-sp-content" />
  </main>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js